// Official Deadlock art and palette, served by the deadlock-api.com asset bucket
// (indexes: /v1/assets/icons, /v1/assets/images, /v1/assets/colors).
const ASSETS = "https://assets-bucket.deadlock-api.com/assets-api-res";

export const GAME_ICONS = {
  soul: `${ASSETS}/icons/hud/icons/icon_souls.svg`,
  rejuvenator: `${ASSETS}/icons/hud/icons/rejuvenator.svg`,
  weapon: `${ASSETS}/icons/builds/citadel_build_tag_weapon.svg`,
  spirit: `${ASSETS}/icons/builds/citadel_build_tag_spirit.svg`,
  vitality: `${ASSETS}/icons/builds/citadel_build_tag_vitality.svg`,
};

// Large art used as backdrops; all decorative, so a failed load just leaves the
// page's own background showing.
export const GAME_ART = {
  smoke: `${ASSETS}/images/main_menu/pick_screen/smoke_bg.webp`,
  cardBacker: `${ASSETS}/images/main_menu/pick_screen/card_backer.webp`,
  ranked: `${ASSETS}/images/main_menu/play/card_ranked.webp`,
  play: `${ASSETS}/images/main_menu/menu_images/menu_play_deadlock.webp`,
  minimap: `${ASSETS}/images/maps/minimap_midtown_mid.png`,
};

// Page backdrop per section of the site (see Layout).
export const backdropForPath = (path) => {
  if (/^\/matches\//.test(path)) return { src: GAME_ART.minimap, position: "center", opacity: 0.08 };
  if (/^\/leaderboard/.test(path)) return { src: GAME_ART.ranked, position: "top right", opacity: 0.14 };
  if (/^\/players/.test(path)) return { src: GAME_ART.play, position: "top right", opacity: 0.14 };
  return { src: GAME_ART.smoke, position: "top", opacity: 0.18 };
};

// Shop categories as the game colours them (weapon_color, fortitude_color, spirit_color).
export const ITEM_SLOTS = {
  weapon: { label: "Weapon", color: "#E58A00", icon: `${ASSETS}/icons/builds/citadel_build_tag_weapon.svg` },
  vitality: { label: "Vitality", color: "#649717", icon: `${ASSETS}/icons/builds/citadel_build_tag_vitality.svg` },
  spirit: { label: "Spirit", color: "#8A55B3", icon: `${ASSETS}/icons/builds/citadel_build_tag_spirit.svg` },
};
export const ITEM_SLOT_ORDER = ["weapon", "vitality", "spirit"];

// `colors` from the asset API: team1/team2, lane_*_color and the item categories.
export const GAME_COLORS = {
  amber: "#D4A373", // site accent; the in-game team1 colour is #D4860B
  sapphire: "#4D75C3",
  lanes: { yellow: "#F9D506", blue: "#1F5FCE", green: "#70DB32", purple: "#C241A8" },
  weapon: "#E58A00",
  spirit: "#8A55B3",
  vitality: "#649717",
};

export const laneColor = (lane) => {
  const key = String(lane || "").toLowerCase();
  return Object.entries(GAME_COLORS.lanes).find(([name]) => key.includes(name))?.[1] || null;
};

// badge_level encodes tier * 10 + subrank (e.g. 116 = Eternus 6); tier 0 is unranked.
export const rankBadgeUrl = (badgeLevel, size = "sm") => {
  const level = Number(badgeLevel);
  if (!Number.isFinite(level) || level <= 0) return `${ASSETS}/images/ranks/rank0/badge_${size}.webp`;
  const tier = Math.floor(level / 10);
  const subrank = level % 10;
  if (tier < 1 || tier > 11 || subrank < 1 || subrank > 6) return null;
  return `${ASSETS}/images/ranks/rank${tier}/badge_${size}_subrank${subrank}.webp`;
};

// Game art is decorative: if the CDN is unreachable the icon simply disappears.
export const hideOnError = (event) => {
  event.currentTarget.style.display = "none";
};
